var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7655 10.1656C11.6155 10.3156 11.4121 10.3998 11.1999 10.3998C10.9878 10.3998 10.7844 10.3156 10.6343 10.1656L7.99993 7.53119L5.36554 10.1656C5.21465 10.3113 5.01257 10.3919 4.80281 10.3901C4.59306 10.3883 4.39241 10.3042 4.24408 10.1558C4.09575 10.0075 4.01162 9.80687 4.0098 9.59711C4.00797 9.38735 4.08861 9.18527 4.23434 9.03439L7.43434 5.83439C7.58436 5.68441 7.7878 5.60016 7.99993 5.60016C8.21207 5.60016 8.41551 5.68441 8.56553 5.83439L11.7655 9.03439C11.9155 9.18441 11.9998 9.38786 11.9998 9.59999C11.9998 9.81212 11.9155 10.0156 11.7655 10.1656Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/ChevronUp.cc816b2bd8876643da23850731cc268c.svg";
export { ForwardRef as ReactComponent };